var styles = [".badge[_ngcontent-%COMP%]{width:30px;cursor:pointer;border:1px solid grey;margin-bottom:5px}"];
export { styles as styles };
